import { useCallback } from 'react';

import {
  generateProjectName,
  isContinuousOptimizationType,
  isDocumentProject,
} from 'src/data/project';
import { useErrorHandler } from 'src/services/useErrorHandler';
import { useProjectActions, useProjectFolderActions } from 'src/store';
import { useProjectSettingsPopup } from 'src/views/ProjectSettingsPopup';

import { usePageActions } from '../store';

const isDefaultProjectName = (project) => project.name === generateProjectName(project?.brief);

export const useUpdateProject = ({ isDisplayedBeforeGoBack, onConfirm, onCancel } = {}) => {
  const openProjectSettingsPopup = useProjectSettingsPopup();
  const handleError = useErrorHandler();
  const projectActions = useProjectActions();
  const pageActions = usePageActions();
  const projectFolderActions = useProjectFolderActions();

  /**
   * Handle project name change action
   */
  return useCallback(() => {
    const project = projectActions.getCurrentProject();
    const oldName = pageActions.getProjectName();
    const projectSuggestedTitle = projectActions.getProjectSuggestedTitle();

    openProjectSettingsPopup({
      isDisplayedBeforeGoBack,
      name: isDefaultProjectName(project) ? projectSuggestedTitle : oldName,
      projectFolderId: project.projectFolder?.id,
      isDocument: isDocumentProject(project?.type),
      displayMoveToFolder: !isContinuousOptimizationType(project?.type),
      displayName: true,
      onConfirm: async ({ name, projectFolderId }) => {
        try {
          pageActions.setProjectName(name);
          await projectActions.updateProject({ id: project?.id, name, projectFolderId });
          await projectFolderActions.decreaseFolderProjectCount(project.projectFolder?.id);
          await projectFolderActions.increaseFolderProjectCount(projectFolderId);

          if (onConfirm) {
            await onConfirm();
          }
        } catch (error) {
          pageActions.setProjectName(oldName);
          handleError(error);
        }
      },
      onCancel,
    });
  }, [
    projectActions,
    pageActions,
    openProjectSettingsPopup,
    isDisplayedBeforeGoBack,
    projectFolderActions,
    onConfirm,
    handleError,
    onCancel,
  ]);
};
